import { Loader2 } from 'lucide-react'
import type { CSSProperties } from 'react'

type SpinnerSize = 'sm' | 'md' | 'lg' | number

const SIZE_MAP: Record<'sm' | 'md' | 'lg', number> = { sm: 12, md: 16, lg: 20 }

// The one spinner used everywhere. Wraps a single lucide icon (Loader2) with the shared `.spinner`
// animation (see index.css) so the whole app has one look and speed. Color is inherited from the
// surrounding text (currentColor) — set `color` on the parent (or pass `style`/`className`) when a
// specific accent is wanted. Pass `label` to expose it to assistive tech; otherwise it's aria-hidden.
export default function Spinner({
  size = 'sm',
  className,
  style,
  strokeWidth,
  label,
  'data-testid': dataTestId,
}: {
  size?: SpinnerSize
  className?: string
  style?: CSSProperties
  strokeWidth?: number
  label?: string
  'data-testid'?: string
}) {
  const px = typeof size === 'number' ? size : SIZE_MAP[size]
  return (
    <Loader2
      size={px}
      strokeWidth={strokeWidth}
      className={`spinner${className ? ` ${className}` : ''}`}
      style={style}
      role={label ? 'img' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      data-testid={dataTestId}
    />
  )
}
